export default __webpack_public_path__ + "static/media/ser2-2.5c9e1f12.jpg";